import { useCallback } from 'react';

import { useLocation } from '@xing-com/crate-core-router';

export type GetAllSearchParameters = () => string;

export type UseSearchParameters = () => {
  getAllSearchParameters: GetAllSearchParameters;
};
export const useSearchParameters: UseSearchParameters = () => {
  const location = useLocation();

  const getAllSearchParameters = useCallback(() => {
    const search = new URLSearchParams(location.search);

    return search.toString();
  }, [location.search]);

  return { getAllSearchParameters };
};
